import React from 'react';
import classnames from 'classnames';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Translate, withLocalize } from 'react-localize-redux';
import { withRouter } from 'react-router';
import { NavLink } from 'react-router-dom';
import { isNullOrUndefined } from '../../store/storeFunctions';
import { searchActions, propertySkSearchBy } from '../../store/searchStore';
import { hasPermission } from '../../store/apiWrapper';
import { isIE } from '../common/utils';
import { PdfExportButton } from '../common/refButtons';
import Paging from '../common/pagingComponent';
import MainHeader from './mainHeader';
import SimpleSearchStats from '../common/simpleSearchStats';
import BbCheckbox from "../styling/bbCheckbox";

import './headersCommon.scss'

import flagSk from "../../img/vlajka_sk.svg";

const TAB_ORDER = {
    "search": 0,
    "results": 1,
    "report": 2,
    "ownership-deed": 3,
    "cadastre-map": 4
}

class PropertySkHeader extends React.Component {

    state = {
        pageLinks: [],
        showResults: false,
        showReport: false,
        showOwnership: false,
        showMap: false
    }

    componentDidMount() {
        this.props.resetPdfExport();
        this.setLinks();
    }

    componentDidUpdate(prevProps) {
        if (this.props.location.pathname === prevProps.location.pathname) return;
        this.setLinks();
    }

    setLinks() {
        if (this.endsWith(this.props.location.pathname, '/property-sk')) { this.setState({ pageLinks: [], showResults: false, showReport: false, showOwnership: false, showMap: false }); return; }

        let pathName = "";
        let currentLinks = this.state.pageLinks;

        if (this.endsWith(this.props.location.pathname, '/results') || this.props.location.pathname.includes('/results')) pathName = "results";
        if (this.endsWith(this.props.location.pathname, '/report' || this.props.location.pathname.includes('/report'))) pathName = "report";
        if (this.endsWith(this.props.location.pathname, '/ownership-deed') || this.props.location.pathname.includes('/ownership-deed')) pathName = "ownership-deed";
        if (this.endsWith(this.props.location.pathname, '/cadastre-map') || this.props.location.pathname.includes('/cadastre-map')) pathName = "cadastre-map";

        let existingLinkIndex = currentLinks.findIndex(x => x.link === pathName)

        if (existingLinkIndex >= 0) {
            if (currentLinks[existingLinkIndex].location.search !== this.props.location.search) {
                currentLinks[existingLinkIndex].location = this.props.location;
                currentLinks = currentLinks.filter(link => link.order <= TAB_ORDER[pathName]);
                this.setState({ ...this.state, pageLinks: currentLinks });
            }
        }
        else {
            this.state.pageLinks.push({ order: TAB_ORDER[pathName], link: pathName, location: this.props.location })
        }

        var reportLink = currentLinks.find(x => x.link === 'report');
        var showMap = !isNullOrUndefined(reportLink) && (reportLink.location.search.includes('entityId') || reportLink.location.search.includes('hash'));

        this.setState({ ...this.state, showResults: currentLinks.findIndex(x => x.link === 'results') >= 0, showReport: !isNullOrUndefined(reportLink), showOwnership: currentLinks.findIndex(x => x.link === 'ownership-deed') >= 0, showMap: showMap })
    }

    componentWillUnmount() {
        this.setState({ pageLinks: [] });
    }

    render() {
        const isOnSearchpage = this.endsWith(this.props.location.pathname, '/property-sk');
        const isOnResultsPage = this.endsWith(this.props.location.pathname, '/results') || this.props.location.pathname.includes('/results');
        const isOnReportPage = this.endsWith(this.props.location.pathname, '/report') || this.props.location.pathname.includes('/report');
        const isOnOwnershipDocumentPage = this.endsWith(this.props.location.pathname, '/ownership-deed') || this.props.location.pathname.includes('/ownership-deed');
        const isOnCadasterMapPage = this.endsWith(this.props.location.pathname, '/cadastre-map') || this.props.location.pathname.includes('/cadastre-map');

        return (<>
            <MainHeader label='Property.Header' flag={flagSk} {...this.props} />
            {!this.props.isMobile && <div className={classnames('tabs tabs-subheader shadowed', { 'tinted': this.props.tinted })}>
                <ul style={{ border: "none" }}>
                    <li className={`tab-link ${isOnSearchpage ? "is-active" : ""}`}>
                        <NavLink to={{ pathname: this.props.match.url, state: this.props.location.state }}>
                            <Translate id="Search.Common.Search" />
                        </NavLink>
                        <div className="search-progress-short" style={{ display: isOnSearchpage ? "" : "none" }}></div>
                    </li>
                    {(isOnResultsPage || this.state.showResults) && <li className={`tab-link ${isOnResultsPage ? "is-active" : ""}`}>
                        <a onClick={() => this.props.history.push(`${this.props.match.url}/results` + this.getPatchParamsForTab("results"))}>
                            <Translate id="Search.Common.Results" />
                        </a>
                        <div className="search-progress-short" style={{ display: isOnResultsPage ? "" : "none" }}></div>
                    </li>}
                    {(isOnReportPage || this.state.showReport) && <li className={`tab-link ${isOnReportPage ? "is-active" : ""}`}>
                        <a onClick={() => this.props.history.push(`${this.props.match.url}/report` + this.getPatchParamsForTab("report"))}>
                            <Translate id="Common.Report" />
                        </a>
                        <div className="search-progress-short" style={{ display: isOnReportPage ? "" : "none" }}></div>
                    </li>}
                    {(isOnOwnershipDocumentPage || this.state.showOwnership) && <li className={`tab-link ${isOnOwnershipDocumentPage ? "is-active" : ""}`}>
                        <a onClick={() => this.props.history.push(`${this.props.match.url}/ownership-deed` + this.getPatchParamsForTab("ownership-deed"))}>
                            <Translate id="PropertySk.OwnershipDocument" />
                        </a>
                        <div className="search-progress-short" style={{ display: isOnOwnershipDocumentPage ? "" : "none" }}></div>
                    </li>}
                    {((isOnCadasterMapPage || this.state.showMap) && hasPermission(null, "CadastreMap")) && <li className={`tab-link ${isOnCadasterMapPage ? "is-active" : ""}`}>
                        <a onClick={() => this.props.history.push(`${this.props.match.url}/cadastre-map` + this.getPatchParamsForTab("report"))}>
                            <Translate id="PropertySk.CadastreMap" />
                        </a>
                        <div className="search-progress-short" style={{ display: isOnCadasterMapPage ? "" : "none" }}></div>
                    </li>}
                </ul>
                {(isOnResultsPage || isOnReportPage || isOnOwnershipDocumentPage) && this.renderPdfExport(isOnReportPage)}
            </div>}
            {!this.props.isMobile && (isOnResultsPage || isOnReportPage) && this.renderSearchManager(isOnReportPage)}
        </>)
    }

    getPatchParamsForTab(tab) {
        if (isNullOrUndefined(tab)) return "";
        let pageLink = this.state.pageLinks.filter(x => x.link === tab);
        if (isNullOrUndefined(pageLink) || pageLink.length === 0 || isNullOrUndefined(pageLink[0].location)) return "";
        return pageLink[0].location.search;
    }

    endsWith = (str, suffix) => isNullOrUndefined(str) || isNullOrUndefined(suffix) ? false : str.lastIndexOf(suffix, str.length - suffix.length) === str.length - suffix.length;

    renderSearchManager = (isOnReportPage) => {
        if (isNullOrUndefined(this.props.search.propertySk) || isNullOrUndefined(this.props.search.propertySk.data))
            return null;

        const params = { ...this.props.search.propertySk.params };
        const data = { ...this.props.search.propertySk.data };
        const currentPage = Math.round(params.offset / params.count) + 1;
        const totalPages = Math.ceil(data.totalCount / params.count);

        return (
            <div
                className={classnames(
                    "search-results-manager-wrapper hide-on-mobile",
                    { "relative": isIE() && !this.props.layout.scrolled, "fixed": isIE() && this.props.layout.scrolled, "tinted": this.props.tinted }
                )}
                style={((!isIE() || this.props.layout.scrolled) ? { top: `${this.props.layout.topMenuHeight}` } : {})}
            >
                <div className={classnames("search-results-manager", { "tinted": this.props.tinted })}>
                    <div className="result-counts-ordering-paging" style={{ justifyContent: "space-between" }}>
                        {!isOnReportPage && <SimpleSearchStats foundCount={data.totalCount} page={currentPage} totalPages={totalPages} />}
                        {!isOnReportPage && totalPages > 1 && <>
                            <div className='result-paging hide-on-mobile'>
                                <Paging selectedPage={currentPage} totalPages={totalPages} setPage={(pg) => this.setPage(pg, params)} />
                            </div>
                            <SimpleSearchStats foundCount={data.totalCount} page={currentPage} totalPages={totalPages}
                                classNames={{ "invisible": true, "hide-on-mobile": true }} />
                        </>}
                        {isOnReportPage && <div className="bb-chk-pdf-export">
                            <BbCheckbox name="pdf-all" label={this.props.translate("Charts.CheckAll")} id="pdf_all"
                                value={this.props.search.exportSettings.all && this.props.search.exportSettings.ids.length === 0}
                                onChange={(v) => this.props.setAllToPdfExport(v)} />
                        </div>}
                    </div>
                </div>
            </div>
        )
    }

    getCurrentCount = (searchBy, data) => {
        switch (searchBy) {
            case propertySkSearchBy.companyOwners:
            case propertySkSearchBy.personOwners:
                return data.owners.length
            case propertySkSearchBy.companyOwnerDeeds:
            case propertySkSearchBy.personOwnerDeeds:
                return data.length;
            case propertySkSearchBy.ownershipDeed:
            case propertySkSearchBy.registrationNumber:
            case propertySkSearchBy.landId:
            case propertySkSearchBy.flatNumber:
                return data.ownershipDocuments.length;
            default:
                return 0;
        };
    }

    setPage = (pg, params) => {
        params.offset = (pg - 1) * params.count;
        const query = Object.keys(params).filter(f => params[f] !== undefined).map(k => `${k}=${encodeURIComponent(params[k])}`).join("&");
        this.props.history.push(`/search/property-sk/results?${query}`);
    }

    renderPdfExport = (withCheck) => {
        const data = isNullOrUndefined(this.props.search) || isNullOrUndefined(this.props.search.propertySk) ? null : this.props.search.propertySk.data;

        if (isNullOrUndefined(data))
            return null;

        const exportSettings = this.props.search.exportSettings;
        const isEnabled = !withCheck || (isNullOrUndefined(exportSettings.error) && (exportSettings.all === true || exportSettings.ids.length > 0));
        const disabledKey = isNullOrUndefined(exportSettings.error) ? undefined : exportSettings.error.message;

        return (
            <div className='search-pdf-export'>
                <div className='references print-hidden'>
                    <div className="ref-buttons" style={{ display: 'flex' }}>
                        <PdfExportButton key='propertySk' onClick={() => this.props.propertySkExportPdf(withCheck)} isEnabled={isEnabled} disabledKey={disabledKey} />
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(withLocalize(connect(
    state => ({ search: { ...state.search }, layout: { ...state.layout } }),
    dispatch => bindActionCreators(searchActions, dispatch)
)(PropertySkHeader)));